var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoltage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sign",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB300"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 7.5a5 5 0 0 1 8.6 0l23 40A5 5 0 0 1 55 55H9a5 5 0 0 1-4.3-7.5z",
    fill: "url(#sign)",
    stroke: "#E08A00",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12L12 46",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 18L23 36h8l-4 14 14-19h-8l4-13z",
    fill: "#2B2F45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltage);
export default __webpack_public_path__ + "static/media/voltage.8b86a4d5018418e88ff4f790a3ad7b85.svg";
export { ForwardRef as ReactComponent };